<div id="crop-health-map-types-legend">
  @for (mapType of cropHealthMapTypes; track mapType.key) {
    <div
      class="map-item-container"
      [class.selected]="selectedMapType.key === mapType.key"
      (click)="cropHealthService.setSelectedMapType(mapType.key)">
      <div class="d-flex align-items-start gap-2">
        <span>
          @switch (mapType.key) {
            @case ('ndvi') {
              <dk-ndvi-map-icon />
            }
            @case ('ndmi') {
              <dk-ndmi-map-icon />
            }
            @case ('inspection') {
              <dk-inspection-map-icon />
            }
            @case ('risk') {
              <dk-risk-map-icon />
            }
          }
        </span>
        <div>
          <p class="map-type-label">
            <span> {{ mapType.label | translate }} </span>
            @if (mapType.disabled) {
              <span class="premium_required"
                >({{ 'doktar_app.services.crop_monitoring.irrigation_program.premium_required' | translate }})</span
              >
            }
          </p>
          <p class="map-type-description">{{ mapType.description | translate }}</p>
        </div>
      </div>
      <div>
        @if (cropHealthService.selectedMapType.value === mapType.value) {
          <i class="ph-fill ph-radio-button"></i>
        }
      </div>
    </div>
  }
</div>
